export default __webpack_public_path__ + "static/media/logo.80f71e85.png";